<template>
  <div class="theme-toggle" @click="toggleTheme" :title="toggleTitle">
    <!-- Ícone do Sol (tema claro) -->
    <svg v-if="isDarkTheme" viewBox="0 0 24 24">
      <path d="M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12zM12 2a1 1 0 0 1 1 1v1a1 1 0 0 1-2 0V3a1 1 0 0 1 1-1zM21 12a1 1 0 0 1-1 1h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1zM5 12a1 1 0 0 1-1 1H3a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1zM19.07 4.93a1 1 0 0 1 0 1.41l-.71.71a1 1 0 0 1-1.41-1.41l.71-.71a1 1 0 0 1 1.41 0zM5.64 18.36a1 1 0 0 1 0 1.41l-.71.71a1 1 0 0 1-1.41-1.41l.71-.71a1 1 0 0 1 1.41 0zM4.93 4.93a1 1 0 0 1 1.41 0l.71.71a1 1 0 0 1-1.41 1.41l-.71-.71a1 1 0 0 1 0-1.41zM18.36 18.36a1 1 0 0 1 1.41 0l.71.71a1 1 0 0 1-1.41 1.41l-.71-.71a1 1 0 0 1 0-1.41z"/>
    </svg>
    <!-- Ícone da Lua (tema escuro) -->
    <svg v-else viewBox="0 0 24 24">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: "ThemeToggle",
  data() {
    return {
      isDarkTheme: false,
    };
  },
  computed: {
    toggleTitle() {
      return this.isDarkTheme ? 'Mudar para tema claro' : 'Mudar para tema escuro';
    }
  },
  mounted() {
    this.checkCurrentTheme();
    // Escutar mudanças no tema do sistema
    if (window.matchMedia) {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', this.handleSystemThemeChange);
    }
  },
  beforeUnmount() {
    // Remover listener quando o componente for desmontado
    if (window.matchMedia) {
      window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', this.handleSystemThemeChange);
    }
  },
  methods: {
    checkCurrentTheme() {
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme) {
        this.isDarkTheme = savedTheme === 'dark';
      } else {
        this.isDarkTheme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      }
    },
    toggleTheme() {
      this.isDarkTheme = !this.isDarkTheme;
      this.applyTheme();
      // Salvar preferência no localStorage
      localStorage.setItem('theme', this.isDarkTheme ? 'dark' : 'light');
      
      // Emitir evento para outros componentes que precisem saber sobre a mudança
      this.$emit('theme-changed', this.isDarkTheme ? 'dark' : 'light');
    },
    applyTheme() {
      if (this.isDarkTheme) {
        document.documentElement.setAttribute('data-theme', 'dark');
      } else {
        document.documentElement.removeAttribute('data-theme');
      }
    },
    handleSystemThemeChange(e) {
      // Só atualizar se não há preferência salva
      const savedTheme = localStorage.getItem('theme');
      if (!savedTheme) {
        this.isDarkTheme = e.matches;
        this.applyTheme();
      }
    }
  }
};
</script>

<style scoped>
/* Estilos específicos do componente se necessário */
.theme-toggle {
  /* Os estilos já estão definidos no themes.css */
}
</style> 